import React, { Dispatch, useState } from "react";
import styles from "./DigiteCep.module.css";
import api from "../../utils/axios/api";
import formatCEP from "../../utils/misc/formatCep";

interface DigiteCepProps {
  onClose: () => void;
  cep: string
  setCep: Dispatch<string>
}

const DigiteCep: React.FC<DigiteCepProps> = ({ onClose, cep, setCep }) => {
  const [error, setError] = useState<string>(""); // Estado para gerenciar erros

  const handleConfirm = async () => {
    // Limpa qualquer mensagem de erro anterior
    setError("");

    try {
      await api.post("/geolocation/location-by-cep", { cep: cep.replace(/\D/g, '') });

      // Salva o CEP no localStorage
      const formattedCep = formatCEP(cep);
      localStorage.setItem("cep", formattedCep);

      // Fecha o modal
      onClose();
    } catch (error: any) {
      console.error(error.response?.data || error.message);
      
      // Verifica se o erro é específico de CEP não encontrado
      if (error.response && error.response.status === 404) {
        setError("CEP não encontrado");
      } else {
        setError("Ocorreu um erro ao buscar o CEP");
      }
    }
  };

  return (
    <div className={styles.container}>
      <button className={styles.closeButton} onClick={onClose}>x</button>
      <p className={styles.texto}>Digite o CEP que deseja utilizar:</p>
      <div className={styles.space}>
        <div className={styles.inputContainer}>
          <input
            className={styles.input}
            type="text"
            value={cep}
            onChange={(e) => {
              const digits = e.target.value.replace(/\D/g, '').slice(0, 8);
              const masked = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
              setCep(masked);
              if (error) setError("");
            }}
            placeholder="00000-000"
            maxLength={9}
          />
          {error && <small className={styles.error}>{error}</small>}
        </div>
        <button className={styles.confirm} onClick={handleConfirm}>
          Confirmar
        </button>
      </div>
    </div>
  );
};

export default DigiteCep;
